export const updateSearchQuery = (key, value) => {
  const searchParams = new URLSearchParams(window.location.search);

  // if there were no query params before - don't add them, except `locale`
  // locale is important for determing in which language send emails from user-profile
  if (key !== 'locale' && !searchParams.has(key)) return;

  // if we started with a link to a specific locale like doggio.space?locale=cs&currency=CZK, then we need to update the query
  searchParams.set(key, value);

  const newRelativePathQuery = `${
    window.location.pathname
  }?${searchParams.toString()}`;
  history.replaceState(null, '', newRelativePathQuery);
};

export const withField = (variable, fieldName) => {
  window.localStorage.setItem(fieldName, variable);
  updateSearchQuery(fieldName, variable);
};

export const prepareLinkTo = (to, locale) => {
  return `${to}?locale=${locale}`;
};

/**
 * Validates query parameter and returns fallback if the value is not allowed.
 * @param input The value of the parameter provided by the user.
 * @param collection The set with all the possible values of the parameter.
 * @param fallback Value to return if the parameter is invalid.
 * @returns {string} Input or fallback.
 */
export const validateParam = (input, collection, fallback) => {
  if (
    input &&
    !collection.map(c => c.toLowerCase()).includes(input.toLowerCase())
  )
    return fallback;

  return input;
};
